module.exports = __webpack_public_path__ + "static/media/Jee(Advance)-Exam.999d031b.png";